import { useEffect, useState } from "react";
import { Field, InputGroup } from '@zendeskgarden/react-forms';
import { Button } from '@zendeskgarden/react-buttons';
import { Menu, Item, ISelectedItem, ItemGroup } from '@zendeskgarden/react-dropdowns';
import ChevronDownStroke from '@zendeskgarden/svg-icons/src/16/chevron-down-stroke.svg?react';
import styled from "styled-components";

const StyledInputGroup = styled(InputGroup)`
`;

const StyledItemGroup = styled(ItemGroup)`
    width: 230px;     
    max-width: 100%;
`;

const StyledButton = styled(Button)`
  color: #2F5BFF;
  padding: 10px 16px;
  border: 1px solid #2F5BFF;
`;

type SelectProps = {
  options: ISelectedItem[];
  selectedTag: string;
  setSelectedTag: (value: string) => void;
};

export function Select({ options, setSelectedTag }: SelectProps) {
    const [open, setOpen] = useState<boolean>(false);
    const [selected, setSelected] = useState<ISelectedItem>(options[0]);

    useEffect(() => {
        if (!options || options.length === 0) return;
        setSelected(options[0]);
        setSelectedTag(options[0].value.toString());
    }, [options]);

    return (
    <div>
        <Field>
          <StyledInputGroup>
            <Menu
              button={props => (
                <StyledButton {...props} focusInset isNeutral>
                  {selected.value}
                  <Button.EndIcon isRotated={open}>
                    <ChevronDownStroke />
                  </Button.EndIcon>
                </StyledButton>
              )}
              selectedItems={[selected]}
              onChange={({ selectedItems }) => {
                if(selectedItems == null) return;
                console.log(selectedItems);
                const item = selectedItems[0];

                if (!item) return;

                setSelected(item);
                setSelectedTag(String(item.value));
                setOpen(false);
                }}
            >
              <StyledItemGroup type="radio">
                {options.map(option => (
                  <Item
                    key={option.value}
                    value={option.value}
                    name={option.name}
                  >
                    {option.value}
                  </Item>
                ))}
              </StyledItemGroup>
            </Menu>
          </StyledInputGroup>
        </Field>
    </div>
  );
}